import React, { useEffect, useState } from "react";
import "../nps/NPSModal.css";
import "../nps/EncuestaCorreo.css";
import "./PoliticaDatos.css";

/**
 * PLZ-263: politica de tratamiento de datos del comercio (SPEC-ENCUESTA-CORREO §17).
 * La enlaza el pie del correo de encuestas: https://{comercio}.sealky.co/politica-datos.
 * - El comercio sale del subdominio (como el resto de App Web) y viaja en la ruta del API.
 * - Texto: se muestra tal cual, como texto plano. PDF y enlace: boton que abre el documento del comercio.
 */

const DEFAULT_COLOR = "#29225B";

function companyUuid() {
    return window.location.hostname.split(".")[0];
}

function fecha(s) {
    if (!s) return "";
    return new Date(String(s).replace(" ", "T")).toLocaleDateString("es-CO", { day: "numeric", month: "long", year: "numeric" });
}

function Shell({ company, children }) {
    return (
        <div className="encuesta-page">
            <div className="encuesta-card politica-card">
                {company && (
                    <div className="encuesta-brand">
                        {company.logo && <img className="encuesta-logo" src={company.logo} alt={company.name} />}
                        <span className="encuesta-company">{company.name}</span>
                    </div>
                )}
                {children}
            </div>
            <a className="encuesta-powered" href="https://sealky.co" target="_blank" rel="noopener noreferrer">
                Powered by <strong>Sealky</strong>
            </a>
        </div>
    );
}

function Message({ emoji, title, text }) {
    return (
        <div className="nps-thanks">
            <div className="nps-thanks-emoji">{emoji}</div>
            <h2 className="nps-thanks-title">{title}</h2>
            {text && <p className="nps-thanks-sub">{text}</p>}
        </div>
    );
}

export function PoliticaDatos() {
    const [data, setData] = useState(null);
    const [loadError, setLoadError] = useState(false);

    const load = async () => {
        setLoadError(false);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/privacy-policy/${encodeURIComponent(companyUuid())}`);
            let json = null;
            try {
                json = await res.json();
            } catch (e) {
                // Respuesta que no es JSON
            }
            if (json?.data?.state) setData(json.data);
            else if (res.status === 404) setData({ state: "invalid" });
            else setLoadError(true);
        } catch (e) {
            setLoadError(true);
        }
    };

    useEffect(() => {
        load();
    }, []);

    if (loadError) {
        return (
            <Shell company={null}>
                <Message emoji="📡" title="No pudimos cargar la política" text="Revisa tu conexión." />
                <button className="nps-send nps-send--full" style={{ "--btn-color": DEFAULT_COLOR }} onClick={load}>Reintentar</button>
            </Shell>
        );
    }
    if (!data) {
        return <Shell company={null}><div className="encuesta-loading"><span className="nps-spinner encuesta-spinner" /></div></Shell>;
    }
    if (data.state === "invalid") {
        return <Shell company={null}><Message emoji="🔗" title="Esta página no existe" text="Revisa que hayas abierto el enlace completo." /></Shell>;
    }

    const { company, policy } = data;
    if (data.state === "none" || !policy) {
        return (
            <Shell company={company}>
                <Message
                    emoji="📄"
                    title="Política de Tratamiento de Datos Personales"
                    text={`${company.controller_name} todavía no ha publicado su política aquí. Puedes solicitarla directamente al comercio.`}
                />
            </Shell>
        );
    }

    const link = policy.kind === "file" ? policy.file_url : policy.kind === "url" ? policy.url : null;

    return (
        <Shell company={company}>
            <div className="politica-header">
                <h1 className="politica-title">Política de Tratamiento de Datos Personales</h1>
                <p className="politica-meta">
                    Responsable: {company.controller_name} · Versión {policy.version} · Actualizada el {fecha(policy.created_at)}
                </p>
            </div>
            {policy.kind === "text" && <div className="politica-body">{policy.body}</div>}
            {link && (
                <a
                    className="nps-send nps-send--full politica-link"
                    style={{ "--btn-color": DEFAULT_COLOR, "--btn-text": "#fff" }}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {policy.kind === "file" ? "Ver la política (PDF)" : "Ver la política"}
                </a>
            )}
        </Shell>
    );
}
